import {Controller} from "stimulus"

// Handles inline field validation for contact method inputs.
// Currently validates email format on input.
export default class extends Controller {

    validateEmail(e) {
        var input = e.target
        var value = input.value.trim()
        var errorEl = this._findOrCreateError(input)

        if (value.length === 0) {
            errorEl.textContent = ""
            return
        }

        if (!value.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/)) {
            errorEl.textContent = "Invalid email format"
        } else {
            errorEl.textContent = ""
        }
    }

    _findOrCreateError(input) {
        var existing = input.parentElement.querySelector(".client-validation-error")
        if (existing) return existing

        var errorSpan = document.createElement("span")
        errorSpan.className = "client-validation-error text-rose-600 text-xs mt-1 block"
        input.parentElement.appendChild(errorSpan)
        return errorSpan
    }
}
